import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { GenerateYupValidator } from '../../../../Admin/Catalogs/Reports/components/ModalChangeStatus/GenYupValidator/GenerateYupValidator'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import Box from '../../../../Global/Box'
import InputController from '../../../../Global/InputController'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { PrincipalFields } from './FieldsRequests'
import { useMutation, useQuery } from '@apollo/client'
import { CHANGE_STATUS_PROCESS_REQUESTS } from '../../../../../graphql/Catalog/Processes/Requests/ProcessesRequests'
import { GET_ALL_REASONS_REJECT_CANCELLATION } from '../../../../../graphql/Catalog/Processes/RequestRejectCancellation/requestRejectCancellation'
import { STATUS_REQUEST } from '../../../data/ArrayObjectsStatusRequest'
import { GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS } from '../../../../../graphql/Catalog/Status/StatusTransitions'

const ModalStatusRequests = ({
  requestId,
  currentStatusId,
  reportFolio,
  externalFolio,
  currentStatusName,
  groupCategory,
  refetchMain,
  setCloseModal,
  maxFiles,
  FilesRequirements,
}) => {
  const { showLoading, hideLoading } = useLoading()

  //STATE
  const [fieldsSchema, setFieldsSchema] = useState({})
  const [fieldsToRender, setFieldsToRender] = useState([])
  const [statusSelected, setStatusSelected] = useState(null)
  const [statusSelectedKey, setStatusSelectedKey] = useState(null)
  const [optionsReason, setOptionsReason] = useState([])
  const [files, setFiles] = useState([])
  const [filesMax, setFilesMax] = useState(null)
  const [filesRequirements, setFilesRequirements] = useState([])

  //NEW STATES
  const [nextStatusOptions, setNextStatusOptions] = useState([])
  const [nextStatus, setNextStatus] = useState(null)

  //SCHEMA
  const schema = fieldsSchema

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
  })

  const { loading, error, data } = useQuery(
    GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS,
    {
      variables: {
        current_status_id: parseInt(currentStatusId),
      },
      fetchPolicy: 'no-cache',
    }
  )

  const {
    loading: loadingReasonRejectCancel,
    data: dataReasonRejectCancel,
    error: errorReasonRejectCancel,
  } = useQuery(GET_ALL_REASONS_REJECT_CANCELLATION, {
    variables: {},
    fetchPolicy: 'no-cache',
  })

  const [changeStatus] = useMutation(CHANGE_STATUS_PROCESS_REQUESTS)

  useEffect(() => {
    try {
      if (loadingReasonRejectCancel) return
      if (errorReasonRejectCancel)
        return toastSweetAlert({
          mode: 'error',
          message: errorReasonRejectCancel.message,
        })

      let options =
        dataReasonRejectCancel?.getAllRequestRejectedCancellation?.rows?.map(
          (reason) => {
            return {
              label: reason.reason,
              value: reason.id,
              reason: reason.description,
              type: reason.type,
            }
          }
        )

      if (statusSelectedKey === 'request_cancel') {
        options = options.filter((option) => option.type === 'cancelled')
      }

      if (statusSelectedKey === 'rejected') {
        options = options.filter((option) => option.type === 'rejected')
      }

      setOptionsReason(options)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [
    dataReasonRejectCancel,
    loadingReasonRejectCancel,
    errorReasonRejectCancel,
    setStatusSelectedKey,
  ])

  useEffect(() => {
    if (loading) return
    if (error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })

    const optionsNextStatus = data.getAllStatusTransitionsByCurrentStatusId.map(
      (status) => {
        const nextData = status.NextStatusData
        return {
          value: nextData.id,
          label: nextData.name,
        }
      }
    )

    setNextStatusOptions(optionsNextStatus)
    setValue('status', optionsNextStatus[0].id)
    setStatusSelected(optionsNextStatus[0])
  }, [data, loading, error])

  useEffect(() => {
    if (currentStatusId) {
      // const getNextStatusOptions = STATUS_REQUEST.find(
      //   (status) => status.id === currentStatusId
      // )
      // console.log({getNextStatusOptions})
      // const optionsNextStatus = getNextStatusOptions.nextStatus
      // console.log(optionsNextStatus, 'optionsNextStatus')
      // const options = optionsNextStatus?.map((option) => {
      //   return {
      //     label: option.name,
      //     value: option.id,
      //     // key: option.key,
      //   }
      // })
      // setNextStatusOptions(options)
      // setCurrentStatus(getNextStatusOptions)
      // setValue('status', optionsNextStatus[0].id)
      // setStatusSelected(optionsNextStatus[0])
    }
  }, [currentStatusId])

  useEffect(() => {
    if (maxFiles) {
      setFilesMax(maxFiles)
    }
  }, [maxFiles])

  // useEffect(() => {
  //   if (FilesRequirements) {
  //     const names = FilesRequirements.map((file) => file.description)

  //     setFilesRequirements(names)
  //   }
  // }, [FilesRequirements])

  // useEffect(() => {
  //   if (statusSelectedKey) {
  //     if (statusSelectedKey === 'request_cancel') {
  //       setOptionsReason(
  //         optionsReason.filter((option) => option.type === 'cancelled')
  //       )
  //     }

  //     if (statusSelectedKey === 'rejected') {
  //       setOptionsReason(
  //         optionsReason.filter((option) => option.type === 'rejected')
  //       )
  //     }
  //   }
  // }, [statusSelectedKey])

  useEffect(() => {
    if (!statusSelected) return
    let fields = []
    switch (statusSelected.name) {
      case 'new_request':
        break
      default:
        fields = GenerateYupValidator({
          fields: PrincipalFields,
        })

        setFieldsSchema(fields)
        setFieldsToRender(PrincipalFields)
        break
    }
  }, [statusSelected, statusSelectedKey])

  const handleDrop = (e, limitFiles) => {
    e.preventDefault()
    if (files.length >= limitFiles || e.dataTransfer.files.length > limitFiles)
      return toastSweetAlert({
        mode: 'error',
        message: `Solo puedes subir ${
          limitFiles === 1 ? 'un archivo' : `${limitFiles} archivos`
        }`,
      })

    //Validate all files
    for (let i = 0; i < e.dataTransfer.files.length; i++) {
      const file = e.dataTransfer.files[i]

      const getType = file.type.split('/')[1]

      const allowedTypes = ['png', 'jpeg', 'jpg', 'pdf']

      if (!allowedTypes.includes(getType)) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Este tipo de archivo no esta permitido',
        })
      }

      const allowedSize = 1024 * 1024 * 5

      if (file.size > allowedSize) {
        return toastSweetAlert({
          mode: 'error',
          message: 'El archivo es muy grande',
        })
      }
    }

    const newFiles = [...e.dataTransfer.files]
    setFiles((prevFiles) => [
      ...prevFiles,
      ...newFiles.slice(0, 5 - prevFiles.length),
    ])
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleRemoveFile = (index) => {
    const newFiles = files.filter((file, i) => i !== index)
    setFiles(newFiles)
  }

  const resetForm = () => {}

  const onSubmit = async (data) => {
    // if (
    //     data?.internal_comments?.trim() === '' ||
    //     data.internal_comments === null ||
    //     data.internal_comments === undefined
    // )
    //   return toastSweetAlert({
    //     mode: 'error',
    //     message: 'Debe agregar un comentario privado',
    //   })

    const response = await toastSweetAlert({
      mode: 'modalConfirmCancel',
      icon: 'warning',
      message: `¿Estás seguro de cambiar al estatus ${
        statusSelected.name || statusSelected
      }?`,
    })

    if (!response.isConfirmed) return
    try {
      showLoading()

      const getReasonCancel = optionsReason.find(
        (option) => option.value === +data.cancel_reason
      )

      const getReasonRejected = optionsReason.find(
        (option) => option.value === +data.rejected_reason
      )
      const { data: dataChangeStatus } = await changeStatus({
        variables: {
          input: {
            attachmentsProcessRequest: files,
            status_id: +data.status,
            next_status_id: +data.status,
            cancelled_reason: getReasonCancel ? getReasonCancel.label : null,
            rejected_reason: getReasonRejected ? getReasonRejected.label : null,
            comments: data?.comments,
            internal_comments: data.internal_comments,
          },
          changeStatusProcessRequestId: +requestId,
        },
      })

      if (dataChangeStatus.changeStatusProcessRequest) {
        await refetchMain()
        return toastSweetAlert({
          mode: 'ok',
          message: 'El estatus de la solicitud ha sido actualizado',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      setFiles([])
      reset()
      setStatusSelected(null)
      setFieldsSchema({})
      setFieldsToRender([])
      setCloseModal(true)
    }
  }
  return (
    <div className="modal-status-box">
      {/* <ContentHeader /> */}

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard={false}
            btnSubmit
            // btnSecondFunction={}
            // btnSecondFunctionTitle="Cancelar"
            content={
              <>
                <div className="row">
                  <div className="col-12 modal-status-box-header">
                    <div className="row">
                      {/* <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 p-2">
                        <span className="title-details">Reporte</span>
                        <br />
                        <span className="content-details">{reportFolio}</span>
                      </div> */}
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Folio externo</span>
                        <br />
                        <span className="content-details">{externalFolio}</span>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Estado actual</span>
                        <br />
                        <span className="content-details">
                          {currentStatusName}
                        </span>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Categoría</span>
                        <br />
                        <span className="content-details">{groupCategory}</span>
                      </div>
                    </div>
                  </div>
                  {fieldsToRender &&
                    fieldsToRender.length > 0 &&
                    fieldsToRender?.map((field, index) => {
                      return (
                        <>
                          {field.name === 'status' ? (
                            <div className={`col-12 p-2`}>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <InputController
                                  name="status"
                                  control={control}
                                  label={field.label}
                                  inputType={field.inputType}
                                  options={nextStatusOptions}
                                  menuPosition="fixed"
                                  placeholderTxt="Selecciona un estado"
                                  changeAction={(e) => {
                                    setStatusSelected(e.label)
                                    // setStatusSelectedKey(e.key)
                                  }}
                                  // valueManual={statusSelected}
                                  // disabled={nextStatusOptions.length === 1}
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'choosen' ? (
                            <div className={`col-12 p-2`}>
                              <div
                                className={`col-sm-${field.colSize} col-md-${field.colSize}`}
                              >
                                <InputController
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  inputType={field.inputType}
                                  placeholderTxt={`Selecciona un ${field.label}`}
                                  options={optionsReason}
                                  menuPosition="fixed"
                                  // changeAction={(e) => }
                                  // changeAction={
                                  //   field.name === 'group'
                                  //     ? (e) => setGroupSelected(e.value)
                                  //     : () => {}
                                  // }
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'date' ? (
                            <div className={`col-12 p-2`}>
                              <div
                                className={`col-sm-${field.colSize} col-md-${field.colSize}`}
                              >
                                <InputController
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  // inputType={field.inputType}
                                  type={field.inputType}
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'textarea' ? (
                            <div className={`col-12 p-2`}>
                              <div
                                className={`col-sm-${field.colSize} col-md-${field.colSize} col-lg-${field.colSize}`}
                              >
                                <InputController
                                  name={field.name}
                                  control={control}
                                  // label={field.label}
                                  inputType={field.inputType}
                                  placeholderTxt={`${field.label} ${
                                    field.label === 'Comentario' ? 'Global' : ''
                                  }`}
                                  label={`${field.label} (${
                                    field.label == 'Comentario Interno'
                                      ? 'privado'
                                      : field.label == 'Comentario'
                                      ? 'Global'
                                      : ''
                                  })`}
                                />
                              </div>
                            </div>
                          ) : (
                            field.inputType === 'attachments' && (
                              <>
                                {field.type === 'payment_voucher' && (
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      padding: '20px',
                                    }}
                                  >
                                    <h6>
                                      Suba el comprobante de pago en la
                                      siguiente area:
                                    </h6>
                                  </div>
                                )}
                                {field.type === 'documentation' && (
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingTop: '20px',
                                    }}
                                  >
                                    <h6>
                                      Suba los siguientes documentos en la
                                      siguiente area:
                                      <ul
                                        style={{
                                          paddingTop: '10px',
                                          color: '#666',
                                        }}
                                      >
                                        {filesRequirements?.map(
                                          (file, index) => (
                                            <li key={index}>{file}</li>
                                          )
                                        )}
                                      </ul>
                                    </h6>
                                  </div>
                                )}
                                <div
                                  className="col-12"
                                  style={{ padding: '20px' }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <label>Archivos adjuntos</label>
                                    <label>
                                      {files.length}/
                                      {maxFiles == 1
                                        ? `1 archivo`
                                        : `${maxFiles} archivos`}
                                    </label>
                                  </div>
                                  {/* Área de arrastrar y soltar */}
                                  <div
                                    className="col-12"
                                    style={{
                                      border: '2px dashed #ccc',
                                      padding: '20px',
                                      textAlign: 'center',
                                      borderRadius: '10px', // Bordes redondeados
                                      backgroundColor: '#f9f9f9', // Fondo claro
                                    }}
                                    onDrop={(e) =>
                                      handleDrop(
                                        e,
                                        field.limitFiles
                                          ? field.limitFiles
                                          : filesMax
                                      )
                                    }
                                    onDragOver={handleDragOver}
                                    accept
                                  >
                                    <div>
                                      <p>Arrastra y suelta archivos aquí</p>
                                      {/* Vista previa de archivos subidos */}
                                      {files.length > 0 && (
                                        <div style={{ marginTop: '20px' }}>
                                          <h4>Archivos subidos:</h4>
                                          <div
                                            style={{
                                              display: 'flex',
                                              flexWrap: 'nowrap',
                                              // gap: '10px',
                                            }}
                                          >
                                            {files?.map((file, index) => (
                                              <div
                                                key={index}
                                                style={{
                                                  textAlign: 'center',
                                                  position: 'relative',
                                                  gap: '5px',
                                                  border: '1px solid #ccc',
                                                  borderRadius: '5px',
                                                }}
                                              >
                                                <button
                                                  onClick={() =>
                                                    handleRemoveFile(index)
                                                  }
                                                  style={{
                                                    position: 'absolute',
                                                    top: '5px',
                                                    right: '5px',
                                                    background: '#ff4d4d',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '50%',
                                                    width: '24px',
                                                    height: '24px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '12px',
                                                  }}
                                                >
                                                  ×
                                                </button>

                                                {file.type.split('/')[0] ===
                                                'image' ? (
                                                  <img
                                                    src={URL.createObjectURL(
                                                      file
                                                    )} // Muestra la vista previa
                                                    alt={file.name}
                                                    style={{
                                                      width: '50px',
                                                      height: '50px',
                                                      objectFit: 'cover',
                                                      borderRadius: '5px',
                                                    }}
                                                  />
                                                ) : (
                                                  <span
                                                    style={{
                                                      fontSize: '40px',
                                                      color: '#ff4d4d',
                                                    }}
                                                  >
                                                    {' '}
                                                    <i
                                                      className={`far fa-file-${
                                                        file.type.split('/')[1]
                                                      }`}
                                                    ></i>
                                                  </span>
                                                )}
                                                <p
                                                  style={{
                                                    // margin: '5px 0',
                                                    fontSize: '12px',
                                                    wordBreak: 'break-all',
                                                  }}
                                                >
                                                  {file.name}
                                                </p>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    {/* Texto de formatos y límite de archivos */}
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginTop: '10px',
                                        fontSize: '14px',
                                        color: '#666',
                                      }}
                                    >
                                      <p>
                                        Formatos permitidos: .png, .jpeg, .jpg y
                                        .pdf - Tamaño máximo: 5MB
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )
                          )}
                        </>
                      )
                    })}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </div>
  )
}

export default ModalStatusRequests
